/* =============================================================
   FrogRush v5 — Vetrina + finestra settimanale

   Calendario unico per tutti (Europe/Rome), nessuno scaglionamento:
   - giovedì 20:00 → domenica 20:00 : drop APERTO, tutto visibile e comprabile
   - domenica 20:00 → giovedì 20:00 : drop COPERTO, card sfocate + countdown

   Lo scaglionamento gio/ven/sab resta morto e non torna: i dati dicevano ~39
   visite il giovedì contro ~8,6 il sabato, quindi il pezzo forte del sabato
   lo vedevano nove persone. Valve ha eliminato daily deal e flash sale nel
   2015 per lo stesso motivo: insegnano ad aspettare invece di comprare.

   Perché la copertura invece esiste: i giochi vanno preparati in anticipo
   (nota, sconto, foto) e non possono essere comprabili prima del drop.
   Fuori dalla finestra non c'è niente da vendere, quindi coprire non costa
   vendite — ma costa il richiamo: un rettangolo sfocato non fa desiderare
   niente. Per questo il tasto "Avvisami" è il motore, non un accessorio.

   Nota cache: le decisioni orarie vivono qui (client) perché le pagine
   Shopify passano dalla CDN. Conseguenza: la sfocatura è cosmetica — il
   contenuto è nell'HTML e chi apre gli strumenti da sviluppatore lo legge.
   Per un drop di giochi va bene; non usare questo meccanismo per dati
   che devono restare davvero segreti.
   ============================================================= */
(function () {
  'use strict';

  const TZ = 'Europe/Rome';
  const OPEN_HOUR = 20;
  const WINDOW_DAYS = 3;   /* gio 20:00 → dom 20:00 */
  const DAY = 86400000;
  const DAYNAMES = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];

  /* Sconto massimo ipotizzabile. Serve solo al suggerimento della barra:
     prima di aggiungere non possiamo sapere quanto paga QUESTO cliente
     (VIP, associazione, preorder...), quindi suggeriamo solo giochi che
     coprono il buco anche nel caso peggiore. Meglio tacere che promettere
     una spedizione gratis che poi non arriva. */
  const MAX_DISCOUNT = 0.40;

  const atrio = document.querySelector('[data-fr-atrio]');
  if (!atrio) return;

  const FREE_SHIP = (parseFloat(atrio.getAttribute('data-free-ship')) || 50) * 100;
  const LOW_STOCK = parseInt(atrio.getAttribute('data-low-stock'), 10) || 8;

  const cards = Array.prototype.slice.call(atrio.querySelectorAll('[data-fr-card]'));
  const shipbar = document.querySelector('[data-fr-shipbar]');

  /* ---------- Orologio Roma ---------- */
  function romeNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));
  }

  /* Giovedì 20:00 più recente (<= now) */
  function prevThu20(now) {
    const d = new Date(now);
    d.setHours(OPEN_HOUR, 0, 0, 0);
    const back = (d.getDay() - 4 + 7) % 7;
    d.setDate(d.getDate() - back);
    if (d > now) d.setDate(d.getDate() - 7);
    return d;
  }

  /* Finestra corrente. Dentro: aperto. Fuori: coperto, e `next` è il
     prossimo giovedì 20:00 verso cui punta il countdown. */
  function windowNow(now) {
    const t0 = prevThu20(now);
    const close = new Date(t0.getTime() + WINDOW_DAYS * DAY);
    const open = now >= t0 && now < close;
    const next = open ? close : new Date(t0.getTime() + 7 * DAY);
    return { t0: t0, close: close, open: open, next: next };
  }

  /* ---------- Countdown ---------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function untilText(target, now) {
    let s = Math.max(0, Math.floor((target - now) / 1000));
    const d = Math.floor(s / 86400); s -= d * 86400;
    const h = Math.floor(s / 3600);  s -= h * 3600;
    const m = Math.floor(s / 60);    s -= m * 60;
    if (d > 0) return d + (d === 1 ? ' giorno ' : ' giorni ') + pad(h) + ':' + pad(m) + ':' + pad(s);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  /* ---------- Card ---------- */
  function applyCard(card, w, now) {
    const soldout = card.getAttribute('data-soldout') === '1';
    const qty     = parseInt(card.getAttribute('data-qty'), 10) || 0;
    const state   = !w.open ? 'locked' : (soldout ? 'soldout' : 'open');

    const stockEl = card.querySelector('[data-fr-stock]');
    const addEl   = card.querySelector('[data-fr-add]');
    const veilEl  = card.querySelector('[data-fr-veil]');
    const cdEl    = card.querySelector('[data-fr-countdown]');

    card.setAttribute('data-state', state);

    /* Coperto: il velo copre la card e il bottone sparisce.
       La sfocatura è CSS, quindi cosmetica — vedi nota in testa al file. */
    if (veilEl) veilEl.hidden = w.open;
    if (addEl)  addEl.hidden  = !w.open || soldout;

    if (!w.open) {
      if (cdEl) cdEl.textContent = untilText(w.next, now);
      /* Coperto: niente copie, sarebbe uno spiffero sul drop. */
      if (stockEl) stockEl.hidden = true;
      card.setAttribute('aria-label', 'Gioco coperto. Si scopre giovedì alle 20:00');
      return;
    }

    card.setAttribute('aria-label', card.getAttribute('data-title') || '');

    /* Copie: il numero e basta. Solo quando è davvero basso — "ne restano 40"
       non invoglia nessuno, e gonfiarlo sarebbe scarsità falsa. */
    if (stockEl) {
      if (soldout || qty <= 0) {
        stockEl.hidden = false;
        stockEl.textContent = 'Esaurito';
      } else if (qty <= LOW_STOCK) {
        stockEl.hidden = false;
        stockEl.textContent = qty === 1 ? 'Ultima copia' : qty + ' copie';
      } else {
        stockEl.hidden = true;
      }
    }
  }

  function render() {
    const now = romeNow();
    const w = windowNow(now);

    atrio.setAttribute('data-window', w.open ? 'open' : 'locked');

    const head = document.querySelector('[data-fr-headline]');
    if (head) {
      head.textContent = w.open
        ? 'Si chiude ' + DAYNAMES[w.close.getDay()] + ' alle 20:00'
        : 'Si scopre ' + DAYNAMES[w.next.getDay()] + ' alle 20:00';
    }

    /* Il countdown grande solo a giochi coperti: a drop aperto conta
       comprare, non contare i secondi. */
    const big = document.querySelector('[data-fr-bigcd]');
    if (big) {
      big.hidden = w.open;
      if (!w.open) big.textContent = untilText(w.next, now);
    }

    /* Pagina sigillata: nessuna card, solo i countdown. Non e' un caso
       degenere da tollerare — e' lo stato normale 4 giorni su 7. */
    if (cards.length === 0) {
      const cds = document.querySelectorAll('[data-fr-countdown]');
      for (let i = 0; i < cds.length; i++) cds[i].textContent = untilText(w.next, now);
      return;
    }

    cards.forEach(function (card) {
      /* Una card rotta non deve portarsi dietro le altre: era esattamente
         il baco che lasciava 4 giochi su 5 senza bottone. */
      try { applyCard(card, w, now); }
      catch (err) { console.error('[FrogRush] card', card.getAttribute('data-fr-card'), err); }
    });
  }

  /* ---------- Pagina stantia dalla CDN ----------
     Ora il sigillo lo decide Liquid, quindi l'HTML e' fotografato al momento
     del render. Se la CDN serve quella foto dall'altra parte del confine
     delle 20:00, il visitatore vede lo stato sbagliato: sigillata dopo
     l'apertura (fastidioso) o aperta dopo la chiusura (perdita).
     In quel caso ricarichiamo una volta sola, con un parametro che scavalca
     la cache, e poi ripuliamo l'URL. Una volta per sessione: un ciclo di
     reload sarebbe peggio del problema. */
  function riallineaSeStantia() {
    const sealed = atrio.getAttribute('data-sealed') === '1';
    const aperto = windowNow(romeNow()).open;
    /* Coerente = sigillata quando è chiuso, aperta quando è aperto.
       Se combaciano non c'è niente da fare. (Avevo scritto la condizione al
       contrario: ricaricava proprio nei due casi in cui era tutto giusto.) */
    if (sealed === !aperto) return;

    try {
      if (sessionStorage.getItem('fr_riallineata')) return;
      sessionStorage.setItem('fr_riallineata', '1');
    } catch (e) { return; /* storage bloccato: meglio non ricaricare mai */ }

    location.replace(location.pathname + '?fr=' + Date.now());
  }

  /* Toglie il parametro anti-cache dalla barra degli indirizzi: serve al
     server, non al cliente. */
  function pulisciUrl() {
    if (location.search.indexOf('fr=') === -1) return;
    try { history.replaceState({}, '', location.pathname); } catch (e) { /* pazienza */ }
  }

  /* ---------- Disponibilità live (la cache Liquid può mentire) ---------- */
  function sweepAvailability() {
    /* A drop coperto non serve: nessuno può comprare, e sarebbero cinque
       richieste ogni cinque minuti per nulla. */
    if (!windowNow(romeNow()).open) return;
    cards.forEach(function (card) {
      if (card.getAttribute('data-soldout') === '1') return;
      fetch('/products/' + encodeURIComponent(card.getAttribute('data-fr-card')) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && p.available === false) {
            card.setAttribute('data-soldout', '1');
            render();
          }
        })
        .catch(function () { /* offline o throttle: resta lo stato Liquid */ });
    });
  }

  /* ---------- Barra spedizione ----------
     total_price di /cart.js è GIÀ al netto degli sconti automatici
     (12% VIP, 12% Asso, 15% Pre-Order...). È la stessa cifra su cui
     Shopify valuta la soglia di spedizione. Non ricalcoliamo nulla:
     chiediamo a lui. Così funziona con qualunque sconto, anche futuro. */
  function money(cents) {
    return (cents / 100).toLocaleString('it-IT', {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 2,
    });
  }

  function pickSuggestion(remaining, inCart) {
    let best = null;
    cards.forEach(function (card) {
      if (card.getAttribute('data-soldout') === '1') return;
      const handle = card.getAttribute('data-fr-card');
      if (inCart.indexOf(handle) !== -1) return;

      const list = parseInt(card.getAttribute('data-price'), 10) || 0;
      /* Copre il buco anche con lo sconto più profondo? Se no, non lo propongo. */
      if (list * (1 - MAX_DISCOUNT) < remaining) return;
      if (!best || list < best.list) best = { card: card, list: list, handle: handle };
    });
    return best;
  }

  /* Elenco di cosa c'è nel carrello, con la × per toglierlo: prima non
     esisteva modo di rimuovere niente senza abbandonare la pagina. */
  function renderItems(cart) {
    const list = shipbar.querySelector('[data-fr-shipbar-items]');
    if (!list) return;
    list.textContent = '';
    (cart.items || []).forEach(function (item) {
      const li = document.createElement('li');
      li.className = 'fr-chip';

      const name = document.createElement('span');
      name.className = 'fr-chip__name';
      name.textContent = item.quantity > 1
        ? item.quantity + '× ' + item.product_title
        : item.product_title;

      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'fr-chip__x';
      x.textContent = '×';
      x.setAttribute('aria-label', 'Togli ' + item.product_title + ' dal carrello');
      x.setAttribute('data-fr-remove', item.key);

      li.appendChild(name);
      li.appendChild(x);
      list.appendChild(li);
    });
  }

  function refreshShipbar() {
    if (!shipbar) return;
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || cart.item_count === 0) { shipbar.hidden = true; return; }

        const msg  = shipbar.querySelector('[data-fr-shipbar-msg]');
        const btn  = shipbar.querySelector('[data-fr-shipbar-add]');
        const fill = shipbar.querySelector('[data-fr-shipbar-fill]');
        const total = cart.total_price;

        shipbar.hidden = false;
        renderItems(cart);

        const pctFull = Math.min(100, Math.round((total / FREE_SHIP) * 100));
        if (fill) fill.style.width = pctFull + '%';

        if (total >= FREE_SHIP) {
          shipbar.setAttribute('data-state', 'free');
          msg.textContent = 'Spedizione gratis · totale ' + money(total);
          btn.hidden = true;
          return;
        }

        const remaining = FREE_SHIP - total;
        const inCart = (cart.items || []).map(function (i) { return i.handle; });
        const pick = pickSuggestion(remaining, inCart);

        shipbar.setAttribute('data-state', 'near');
        msg.textContent = money(total) + ' · ti mancano ' + money(remaining) + ' per la spedizione gratis';

        if (pick) {
          const addBtn = pick.card.querySelector('[data-fr-add]');
          btn.hidden = false;
          btn.textContent = '+ ' + pick.card.getAttribute('data-title') + ' · ' + money(pick.list);
          btn.setAttribute('data-variant-id', addBtn ? addBtn.getAttribute('data-variant-id') : '');
        } else {
          btn.hidden = true;
        }
      })
      .catch(function () { /* offline: la barra resta com'è */ });
  }

  /* ---------- Rimozione dal carrello ---------- */
  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function (r) { if (!r.ok) throw new Error('remove failed: ' + r.status); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        refreshShipbar();
      })
      .catch(function (err) { console.error('[FrogRush] rimozione', err); });
  }

  /* ---------- Add to cart ---------- */
  async function addToCart(btn) {
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Aggiungo...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('cart add failed: ' + res.status);

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      btn.textContent = 'Aggiunto';
      refreshShipbar();
      setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1800);
    } catch (err) {
      console.error('[FrogRush] add-to-cart', err);
      btn.textContent = 'Errore, riprova';
      setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2200);
    }
  }

  document.addEventListener('click', function (e) {
    const rm = e.target.closest('[data-fr-remove]');
    if (rm) { e.preventDefault(); removeItem(rm.getAttribute('data-fr-remove')); return; }

    const add = e.target.closest('[data-fr-add], [data-fr-shipbar-add]');
    if (add) { e.preventDefault(); addToCart(add); }
  });

  /* ---------- Go ---------- */
  function init() {
    pulisciUrl();
    riallineaSeStantia();

    render();
    sweepAvailability();
    refreshShipbar();

    /* Ogni secondo il countdown batte. Allo scoccare delle 20:00 di giovedì
       le card NON possono più comparire da sole: i dati non sono in pagina,
       li ha tenuti il server. Quindi si ricarica — ed è giusto così, perché
       è l'unico modo perché il segreto sia davvero un segreto. */
    let eraAperto = windowNow(romeNow()).open;
    setInterval(function () {
      render();
      const oraAperto = windowNow(romeNow()).open;
      if (oraAperto !== eraAperto) {
        eraAperto = oraAperto;
        const sealed = atrio.getAttribute('data-sealed') === '1';
        if (sealed === oraAperto) {
          /* Il confine è stato attraversato mentre la pagina era aperta:
             quello che serve ora non è in questo HTML. */
          location.replace(location.pathname + '?fr=' + Date.now());
          return;
        }
        sweepAvailability();
        refreshShipbar();
      }
    }, 1000);

    setInterval(sweepAvailability, 300000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
